import { useState } from "react";
import { Button, Tabs } from "antd";
import Itenary from "./Itenary";
import ItenaryForm from "./ItenaryForm";
import { AiOutlineCloseCircle, AiOutlineCheckCircle } from "react-icons/ai";
import InclusionForm from "./InclusionForm";
import ExclusionForm from "./ExclusionForm";

const CustomTabs = (props) => {
  const [openItinerary, setOpenItinerary] = useState(false);
  const [openInclusion, setOpenInclusion] = useState(false);
  const [openExclusion, setOpenExclusion] = useState(false);
  const [itinerary, setItinerary] = useState();
  const [inclusion, setInclusion] = useState();
  const [exclusion, setExclusion] = useState();
  const [indexValue, setIndexValue] = useState();

  const items = [
    {
      key: "1",
      label: `Itinerary`,
      children: (
        <>
          <div className="bg-gray-200 rounded-lg px-8 py-3 flex w-full items-center justify-between">
            <p className=" font-Nunito text-lg font-medium text-gray-600">
              Itinerary
            </p>
            {!props?.isView && (
              <Button
                type="primary"
                onClick={() => {
                  setOpenItinerary(true);
                  setItinerary({});
                  setIndexValue(null);
                }}
              >
                Add Itinerary
              </Button>
            )}
          </div>
          <div className="px-2 py-2 w-full">
            {props?.values?.itinerary?.map((el, index) => {
              return (
                <Itenary
                  values={el}
                  key={index}
                  isUpdate={props?.isUpdate}
                  isView={props?.isView}
                  setItenary={setItinerary}
                  setOpenItenary={setOpenItinerary}
                  indexValue={index}
                  setIndex={setIndexValue}
                  handleDelete={() => {
                    const arr = props?.values?.itinerary?.filter(
                      (_, i) => i !== index
                    );
                    props.setFieldValue("itinerary", [...arr]);
                  }}
                />
              );
            })}
            {props?.errors?.itinerary && props?.touched?.itinerary && (
              <p className="text-red-500 py-1  text-xs font-Nunito font-normal">
                {props?.errors?.itinerary}
              </p>
            )}
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: `Inclusions`,
      children: (
        <>
          <div className="bg-gray-200 rounded-lg px-8 py-3 flex w-full items-center justify-between">
            <p className=" font-Nunito text-lg font-medium text-gray-600">
              Inclusions
            </p>
            {!props?.isView && (
              <Button
                type="primary"
                onClick={() => {
                  setOpenInclusion(true);
                  setInclusion({});
                  setIndexValue(null);
                }}
              >
                Add Inclusion
              </Button>
            )}
          </div>
          <div className="px-2 py-2 w-full">
            {props?.values?.inclusions?.map((el, index) => {
              return (
                <div
                  className="flex gap-2 items-center justify-between border-b border-gray-300 py-2"
                  key={index}
                >
                  <div className=" flex items-center gap-2">
                    <AiOutlineCheckCircle className=" text-xl text-green-600" />
                    <p className=" text-lg font-medium text-gray-800">
                      {el?.content}
                    </p>
                  </div>
                  {!props?.isView && (
                    <div className=" flex items-center gap-2">
                      <Button
                        type="outlined"
                        onClick={() => {
                          setInclusion(el);
                          setOpenInclusion(true);
                          setIndexValue(index);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        type="danger"
                        onClick={() => {
                          const arr = props?.values?.inclusions?.filter(
                            (_, i) => i !== index
                          );
                          props?.setFieldValue("inclusions", [...arr]);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  )}
                </div>
              );
            })}
            {props?.errors?.inclusions && props?.touched?.inclusions && (
              <p className="text-red-500 py-1  text-xs font-Nunito font-normal">
                {props?.errors?.inclusions}
              </p>
            )}
          </div>
        </>
      ),
    },
    {
      key: "3",
      label: `Exclusions`,
      children: (
        <>
          <div className="bg-gray-200 rounded-lg px-8 py-3 flex w-full items-center justify-between">
            <p className=" font-Nunito text-lg font-medium text-gray-600">
              Exclusions
            </p>
            {!props?.isView && (
              <Button
                type="primary"
                onClick={() => {
                  setOpenExclusion(true);
                  setExclusion({});
                  setIndexValue(null);
                }}
              >
                Add Exclusion
              </Button>
            )}
          </div>
          <div className="px-2 py-2 w-full">
            {props?.values?.exclusions?.map((el, index) => {
              return (
                <div
                  className="flex gap-2 items-center justify-between border-b border-gray-300 py-2"
                  key={index}
                >
                  <div className=" flex items-center gap-2">
                    <AiOutlineCloseCircle className=" text-xl text-red-600" />{" "}
                    <p className=" text-lg font-medium text-gray-800">
                      {el?.content}
                    </p>
                  </div>
                  {!props?.isView && (
                    <div className=" flex items-center gap-2">
                      <Button
                        type="outlined"
                        onClick={() => {
                          setExclusion(el);
                          setOpenExclusion(true);
                          setIndexValue(index);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        type="danger"
                        onClick={() => {
                          const arr = props?.values?.exclusions?.filter(
                            (_, i) => i !== index
                          );
                          props?.setFieldValue("exclusions", [...arr]);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  )}
                </div>
              );
            })}
            {props?.errors?.exclusions && props?.touched?.exclusions && (
              <p className="text-red-500 py-1  text-xs font-Nunito font-normal">
                {props?.errors?.exclusions}
              </p>
            )}
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      <Tabs defaultActiveKey="1" items={items} />
      <ItenaryForm
        open={openItinerary}
        onClose={() => setOpenItinerary(false)}
        days={props?.values?.days}
        itenaries={props?.values?.itinerary}
        setFieldValue={props?.setFieldValue}
        values={itinerary}
        index={indexValue}
      />
      <InclusionForm
        open={openInclusion}
        onClose={() => setOpenInclusion(false)}
        inclusions={props?.values?.inclusions}
        setFieldValue={props?.setFieldValue}
        values={inclusion}
        index={indexValue}
      />
      <ExclusionForm
        open={openExclusion}
        onClose={() => setOpenExclusion(false)}
        exclusions={props?.values?.exclusions}
        setFieldValue={props?.setFieldValue}
        values={exclusion}
        index={indexValue}
      />
    </>
  );
};
export default CustomTabs;
